import React from "react";
import { InterviewSidebarSection } from "../Components/InterviewSidebarSection";
import { LoadingBar } from "../../../../components/LoadingComponents/LoadingBar";
import { RowWithSingleField } from "../Components/SidebarComponents";
import { getVerificationResult } from "../../../../services/verificationService";

const isLoading = a => a.isInitialized === false || a.isLoading === true;

export const InterviewSidebarVerification = ({ verificationResults, ...props }) => {
    return (
        <InterviewSidebarSection title="Verification" {...props} className="verification-sidebar">
            <LoadingBar isLoading={isLoading(verificationResults)}>
                <RowWithSingleField
                    title="Name"
                    value={getVerificationResult(verificationResults.data.nameVerification)}
                />
                <RowWithSingleField
                    title="DOB"
                    value={getVerificationResult(verificationResults.data.dateOfBirthVerification)}
                />
                <RowWithSingleField
                    title="SSN"
                    value={getVerificationResult(verificationResults.data.ssnVerification)}
                />
                <RowWithSingleField
                    title="Address"
                    value={getVerificationResult(verificationResults.data.addressVerification)}
                />
            </LoadingBar>
        </InterviewSidebarSection>
    );
};
